import axios from 'axios';

export default {
  state: {
    search_title: [],
    search_titleLoading: false,
    error: null,
    search_titleLoaded: false,
    search_titleError: false
  },
  mutations: {
    SET_SEARCH_TITLE(state, search_title) {
      state.search_title = search_title.data;
      console.log(state.search_title)
      state.search_titleLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_SEARCH_TITLE_LOADING(state, status) {
      state.search_titleLoading = status;
    },
    SET_SEARCH_TITLE_ERROR(state, error) {
      state.search_titleError = error;
    },
    UNSET_SEARCH_TITLE(state) {
      state.search_titleLoaded = false;
      state.search_titleLoading = false;
      state.search_title = [];
    },
  },
  actions: {
    async fetchSearchTitle({ commit, state }, query) {



      try {
        commit('SET_SEARCH_TITLE_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/catalog/search/title/', {
          params: {
            query: query
          }
        });
        commit('SET_SEARCH_TITLE', response.data);
        commit('SET_SEARCH_TITLE_ERROR', null);
      } catch (error) {
        commit('SET_SEARCH_TITLE_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching search_title:', error);
      } finally {
        commit('SET_SEARCH_TITLE_LOADING', false);
      }
    }
  },
  getters: {
    search_title: state => state.search_title,
    search_titleLoading: state => state.search_titleLoading,
    search_titleError: state => state.search_titleError,
    search_titleLoaded: state => state.search_titleLoaded,
  }
}